import { Deserializable } from '../protocols/deserializable';
import { Address } from '../users/dto/address';
import { Gender } from '../types/dto/gender';
import { Pronoun } from '../users/dto/pronoun';

export class SelfEnrolmentSubmission implements Deserializable {
  public previous!: SelfEnrolmentSubmissionDetails;
  public new!: SelfEnrolmentSubmissionDetails;

  onDeserialize(): void {
    const deserialize = window?.injector?.Deserialize;

    if (!!this.previous) {
      this.previous = deserialize?.instanceOf(SelfEnrolmentSubmissionDetails, this.previous);
    }

    if (!!this.new) {
      this.new = deserialize?.instanceOf(SelfEnrolmentSubmissionDetails, this.new);
    }
  }
}

export class SelfEnrolmentSubmissionDetails implements Deserializable {
  public firstName!: string;
  public middleName!: string | null;
  public lastName!: string;
  public preferredName!: string;
  public email!: string;
  public socialInsuranceNumber!: string | null;
  public birthDate!: string;
  public genderId!: number;
  public gender!: Gender;
  public pronounId!: number;
  public pronoun!: Pronoun;
  public primaryPhoneNumberCountryCode!: string;
  public primaryPhoneNumber!: string;
  public secondaryPhoneNumberCountryCode: string | null = null;
  public secondaryPhoneNumber: string | null = null;
  public address!: Address;
  public allowThirdPartyContributions!: boolean;

  onDeserialize(): void {
    const deserialize = window?.injector?.Deserialize;

    if (!!this.gender) {
      this.gender = deserialize.instanceOf(Gender, this.gender);
    }
    if (!!this.pronoun) {
      this.pronoun = deserialize.instanceOf(Pronoun, this.pronoun);
    }
    if (!!this.address) {
      this.address = deserialize.instanceOf(Address, this.address);
    }
  }
}
